/**
 * L'étoile Premium — le même signe partout où un membre apparaît : cartes,
 * classements, listes de participants, page personnelle. Discrète (une étoile,
 * un mot), mais toujours au même endroit : juste après le nom.
 */
import { Star } from 'lucide-react';

export function Etoile({ premium, texte = true }: { premium?: boolean | null; texte?: boolean }) {
  if (!premium) return null;
  return (
    <span
      className="text-match-gradient inline-flex items-center gap-1 align-middle text-[11px] font-medium uppercase tracking-[0.05em]"
      title="Membre Premium"
      aria-label="Membre Premium"
    >
      <Star size={12} strokeWidth={2} className="fill-current" />
      {texte && 'Premium'}
    </span>
  );
}
